export function headerFixed() {
  if (!document.body.classList.contains('template-frontpage')) {
    return;
  }

  const homeHero = document.querySelector('.home-hero');
  const identity = document.querySelector('.identity');
  const identityHeight = document.querySelector('.identity-height');

  if (!homeHero || !identity) {
    return;
  }

  let heroHeight = 0;
  let headerHeight = 0;

  const updateMeasurements = () => {
    heroHeight = homeHero.offsetHeight;
    headerHeight = identityHeight.offsetHeight;
  };

  const checkScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop >= heroHeight - headerHeight) {
      document.body.classList.add('header-fixed');
    } else {
      document.body.classList.remove('header-fixed');
    }
  };

  const identityLink = document.querySelectorAll('.identity a, .home-hero-image');
  identityLink.forEach((el) => {
    el.addEventListener('click', (e) => {
      if (!document.body.classList.contains('header-fixed')) {
        e.preventDefault();

        const scrollTarget = heroHeight - headerHeight;

        window.scrollTo({
          top: scrollTarget,
          behavior: 'smooth'
        });
      }
    });
  })

  updateMeasurements();
  checkScroll();

  window.addEventListener('scroll', checkScroll);

  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth !== window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      updateMeasurements();
      checkScroll();
    }
  });
}